var alignment_rtlignore_default = {
  "alignLeft": "kH4ai",
  "textWrapNowrap": "nEK-m",
  "alignRight": "a9gZD",
  "alignCenter": "dPqYG",
  "sizeFullWidth": "bDk7G",
  "renderedInTable": "o2RlP",
  "sizeOriginal": "_78vwY",
  "sizeContent": "ibcNR",
  "sizeSmall": "_3u6Mm",
  "sizeSmallCenter": "_1yXCC",
  "flex": "Ss4M8",
  "LEFT": "UbpLI",
  "CENTER": "XwuJM",
  "RIGHT": "fxiiu",
  "AUTO": "bFEOM",
  "JUSTIFY": "bEspL"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
